<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<i class="el-icon-back backIcon" @click='goBack'></i>
				<span class="topTitle">专利详情</span>
			</div>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="中文" name="zh">
					<div class="flex">
						<div class="title">专利标题：</div>
						<div class="">{{addBody.title}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利分类：</div>
						<div class="">{{addBody.category}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利封面：</div>
						<ImageDetailVue :imgUrl="addBody.icon" style="width: 200px;height: auto;"></ImageDetailVue>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利图片：</div>
						<div style="display: flex;align-items: center;">
							<img v-for="item in addBody.img.split(',')" :src="imgDomain+item"
								style="width: 200px;height: auto;margin-right: 20px;"></img>
						</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">创建时间：</div>
						<div class="">{{addBody.create_time}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利描述：</div>
						<div class="" style="width: 80%;">{{addBody.desc}}</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="英文" name="en">
					<div class="flex">
						<div class="title">专利标题：</div>
						<div class="">{{addBody.title_e}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利分类：</div>
						<div class="">{{addBody.category_e}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利封面：</div>
						<ImageDetailVue :imgUrl="addBody.icon_e" style="width: 200px;height: auto;"></ImageDetailVue>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利图片：</div>
						<div style="display: flex;align-items: center;">
							<img v-for="item in addBody.img_e.split(',')" :src="imgDomain+item"
								style="width: 200px;height: auto;margin-right: 20px;"></img>
						</div>
					</div>
					<!-- <div class="flex" style="margin-top: 20px;">
						<div class="title">专利URL：</div>
						<a :href="addBody.url_e">{{addBody.url_e}}</a>
					</div> -->
					<div class="flex" style="margin-top: 20px;">
						<div class="title">创建时间：</div>
						<div class="">{{addBody.create_time}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利描述：</div>
						<div class="" style="width: 80%;">{{addBody.desc_e}}</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="日语" name="jp">
					<div class="flex">
						<div class="title">专利标题：</div>
						<div class="">{{addBody.title_j}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利分类：</div>
						<div class="">{{addBody.category_j}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利封面：</div>
						<ImageDetailVue :imgUrl="addBody.icon_j" style="width: 200px;height: auto;"></ImageDetailVue>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利图片：</div>
						<div style="display: flex;align-items: center;">
							<img v-for="item in addBody.img_j.split(',')" :src="imgDomain+item"
								style="width: 200px;height: auto;margin-right: 20px;"></img>
						</div>
					</div>
					<!-- <div class="flex" style="margin-top: 20px;">
						<div class="title">专利URL：</div>
						<a :href="addBody.url_j">{{addBody.url_j}}</a>
					</div> -->
					<div class="flex" style="margin-top: 20px;">
						<div class="title">创建时间：</div>
						<div class="">{{addBody.create_time}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">专利描述：</div>
						<div class="" style="width: 80%;">{{addBody.desc_j}}</div>
					</div>
				</el-tab-pane>
			</el-tabs>
			<div class="dialog-footer" style="margin-top: 30px;">
				<el-button @click="goBack">返 回</el-button>
				<el-button type="primary" @click="editUser('addBody')">编 辑</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		addCvideo,
		editCVideo,
		getCPatent
	} from "@/api/content-manage"
	import ImageUpload from "@/components/ImageUpload"
	import ImageDetailVue from '../../../components/ImageDetail.vue';
	import {
		imgDomain
	} from '@/configs/env';
	export default {
		components: {
			ImageDetailVue,
			ImageUpload
		},
		data() {
			return {
				imgDomain,
				activeName: 'zh',
				formLabelWidth: '120px',
				addBody: {
					id: '',
					title: '',
					icon: '',
					img: '',
					url: '',
					desc: '',
					title_e: '',
					icon_e: '',
					img_e: '',
					url_e: '',
					desc_e: '',
					title_j: '',
					icon_j: '',
					img_j: '',
					url_j: '',
					desc_j: ''
				},
				imgList: [],
				iconList: [],
				imgListEn: [],
				iconListEn: [],
				imgListJp: [],
				iconListJp: [],
				rules: {
					title: [{
						required: true,
						message: '请输入专利标题',
						trigger: 'blur'
					}, ],
					title_e: [{
						required: true,
						message: '请输入专利标题',
						trigger: 'blur'
					}, ],
					title_j: [{
						required: true,
						message: '请输入专利标题',
						trigger: 'blur'
					}, ],
					img: [{
						required: true,
						message: '请上传专利',
						trigger: 'blur'
					}, ],
					img_e: [{
						required: true,
						message: '请上传专利',
						trigger: 'blur'
					}, ],
					img_j: [{
						required: true,
						message: '请上传专利',
						trigger: 'blur'
					}, ],
					icon: [{
						required: true,
						message: '请上传封面',
						trigger: 'blur'
					}, ],
					url: [{
						required: true,
						message: '请输入专利URL',
						trigger: 'blur'
					}, ],
					desc: [{
						required: true,
						message: '请输入专利描述',
						trigger: 'blur'
					}, ],
					icon_e: [{
						required: true,
						message: '请上传封面',
						trigger: 'blur'
					}, ],
					url_e: [{
						required: true,
						message: '请输入专利URL',
						trigger: 'blur'
					}, ],
					desc_e: [{
						required: true,
						message: '请输入专利描述',
						trigger: 'blur'
					}, ],
					icon_j: [{
						required: true,
						message: '请上传封面',
						trigger: 'blur'
					}, ],
					url_j: [{
						required: true,
						message: '请输入专利URL',
						trigger: 'blur'
					}, ],
					desc_j: [{
						required: true,
						message: '请输入专利描述',
						trigger: 'blur'
					}, ]
				},
			}
		},
		mounted() {
			this.addBody.id = this.$route.query.id
			if (this.addBody.id) {
				this.network().getCPatent()
			}
		},
		methods: {
			handleClick(e, a) {
				this.activeName = e.name
			},
			iconInput(e) {
				this.addBody.icon = e[0]
			},
			imgInput(e) {
				this.addBody.img = e[0]
			},
			iconInputEn(e) {
				this.addBody.icon_e = e[0]
			},
			imgInputEn(e) {
				this.addBody.img_e = e[0]
			},
			iconInputJp(e) {
				this.addBody.icon_j = e[0]
			},
			imgInputJp(e) {
				this.addBody.img_j = e[0]
			},
			goBack() {
				this.$router.go(-1)
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$router.push({
					path: '/add-patent-list?id=' + this.addBody.id,
				})
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addCvideo: async () => {
						const {
							status,
							data
						} = await addCvideo({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$message.success('新增成功')
						this.goBack()
					},
					editCVideo: async () => {
						const {
							status
						} = await editCVideo({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
						this.goBack()
					},
					getCPatent: async (uuid) => {
						const {
							data,
							status
						} = await getCPatent({
							id: this.addBody.id
						})
						if (status !== 200) return
						this.addBody = data.result
						if (data.result.icon != null) {
							this.iconList.push(data.result.icon)
						}
						if (data.result.img != null) {
							this.imgList.push(data.result.img)
						}
						if (data.result.icon_e != null) {
							this.iconListEn.push(data.result.icon_e)
						}
						if (data.result.img_e != null) {
							this.imgListEn.push(data.result.img_e)
						}
						if (data.result.icon_j != null) {
							this.iconListJp.push(data.result.icon_j)
						}
						if (data.result.img_j != null) {
							this.imgListJp.push(data.result.img_j)
						}
					},
				}
			},
		},
	}
</script>

<style>
	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.title {
		width: 130px;
		color: #999;
	}
</style>